export default "__VITE_ASSET__mY_WiKZ4__"